import type TRTC from 'trtc-sdk-v5'

let client = {} as TRTC
export const useTrtcStore = defineStore({
  id: 'trtc',
  state: () => ({
    role: 'audience' as 'host' | 'audience', // 直播角色 host:主播，audience:观众
    remoteUsers: {} as {
      [prop: string]: {
        elId: string
        uid: string | number
        streamType: 'main' | 'screen' | ''
      }
    }, // 远程用户、主播  elId：标签ID，uid，streamType：主流或辅流
    joined: false as boolean, // 是否跑完整个流程进房或发布
    /** 摄像头面向模式，摄像头超过两个才给切换 user:前置摄像头,environment:后置摄像头, '':空值代表无*/
    facingMode: 'user' as 'user' | 'environment',
    /* 用户视频是否发布成功 */
    isVideoPublish: false,
    /* 远程用户是否触发首帧 */
    isRemoteUserPirstFrame: false
  }),
  actions: {
    /** 判断是否开始计费 */
    isStartBilling() {
      const roomStore = useRoomStore()
      // 视频通话
      if (
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL &&
        this.isVideoPublish &&
        this.isRemoteUserPirstFrame
      ) {
        const callStore = useCallStore()
        callStore.onStartBilling()
      }
      // 主播开播
      if (
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE &&
        roomStore.isHostLive &&
        this.isVideoPublish
      ) {
        roomStore.setIsStartTimer(true)
      }
    },
    // 判断是否已实例
    isDestroyed(): boolean {
      console.log(client['_room'])
      if (!client['_room']) return false
      return client['_room']._isDestroyed ? true : false
    },
    // 创建实例
    create() {
      console.log('TrtcSDK => 创建实例')
      // 视频的房间才显示遮罩层
      this.setIsShowMask(true)

      client = window.TRTC.create()
    },
    //  加入频道
    async join() {
      const Trtc = window.TRTC
      const runtimeConfig = useRuntimeConfig()
      const i18n = useNuxtApp().$i18n
      const roomStore = useRoomStore()
      const userStore = useUserStore()
      const audioStore = useAudioStore()

      if (!roomStore.rtcInfo.token) return
      // 视频房、通话房才开启定时器
      if (
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE ||
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL
      ) {
        roomStore.setIsTimeout() //开启定时器
      }
      try {
        // 设置角色
        // 视频通话房；视频直播房-主播；语音直播房-在麦；
        if (
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL ||
          (roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE &&
            roomStore.isHostLive) ||
          (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE &&
            audioStore.isOnMicSeat)
        ) {
          await this.setRole('host')
        } else {
          await this.setRole('audience')
        }
        // 进入频道
        const sdkAppId = Number(roomStore.rtcInfo.appId)
        const roomId = Number(roomStore.rtcInfo.channel)
        const userSig = roomStore.rtcInfo.token
        const userId = String(roomStore.rtcInfo.uid)
        const privateMapKey = String(roomStore.rtcInfo.privateMapKey)

        // 根据场景值进房
        await client.enterRoom({
          sdkAppId,
          roomId,
          userSig,
          userId,
          privateMapKey,
          scene: Trtc.TYPE.SCENE_LIVE,
          role:
            this.role === 'host'
              ? Trtc.TYPE.ROLE_ANCHOR
              : Trtc.TYPE.ROLE_AUDIENCE,
          enableAutoPlayDialog: false, // 是否开启 SDK 自动播放失败弹窗,设false 监听事件来用自己的弹窗
          autoReceiveAudio: false // 是否自动接收音频。
        })

        console.log(
          'TrtcSDK => 加入频道成功',
          roomStore.roomId.toString(),
          userStore.userInfo.uid,
          new Date(),
          new Date().getTime()
        )
        console.log(client['_room'].roomId)
        // 监听远程用户
        // 语音房启用 监听远程用户
        if (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE) {
          client.on(
            Trtc.EVENT.REMOTE_AUDIO_AVAILABLE,
            this.onRemoteAudioAvailable
          ) // 发布
          client.on(
            Trtc.EVENT.REMOTE_AUDIO_UNAVAILABLE,
            this.onRemoteAudioUnavailable
          ) // 取消发布
          // 音量回调事件
          client.on(Trtc.EVENT.AUDIO_VOLUME, this.onAudioVolume)

          // 开启音量回调，并设置每 1500ms 触发一次事件
          client.enableAudioVolumeEvaluation(750)
        }

        // 视频的房间启用，视频直播和1v1启用 监听远程用户
        if (
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE ||
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL
        ) {
          // 当远端用户成功发布视频轨道之后
          client.on(
            Trtc.EVENT.REMOTE_VIDEO_AVAILABLE,
            this.onRemoteVideoAvailable
          )
          // 当远端用户取消发布视频轨道
          client.on(
            Trtc.EVENT.REMOTE_VIDEO_UNAVAILABLE,
            this.onRemoteVideoUnavailable
          )
        }

        // 自动播放失败事件
        client.on(Trtc.EVENT.AUTOPLAY_FAILED, () => {
          // 引导用户点击页面，可以弹窗提示。
          showConfirmDialog({
            message: i18n.t('room.AtuoPlayFailedMsg'),
            confirmButtonText: i18n.t('public.Confirm'),
            showCancelButton: false,
            className: 'private-dialog-customize single-btn'
          }).catch((error) => {
            console.log(error)
          })
        })

        // 视频房的采集设备播放
        if (
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL ||
          (roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE &&
            roomStore.isHostLive)
        ) {
          this.manageLocalAllTrack(true)
        }

        // 语音房初始化时 如果用户自己在麦位上就发布本地音频轨道
        if (
          roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE &&
          audioStore.isOnMicSeat
        ) {
          this.manageLocalAudioMicrophone(true)
        }

        this.joined = true
        // 如果还没此状态还没更新，就更新
        if (
          roomStore.isShowMask &&
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE
        ) {
          this.setIsShowMask(roomStore.isStartLive)
        }
      } catch (error) {
        console.log('TrtcSDK => 进房函数报错', error)
      }
    },
    /**
     * 设置角色
     */
    async setRole(value: 'host' | 'audience') {
      // 不同值才设置
      if (this.role !== value) {
        console.log('TrtcSDK => 开始设置角色', value)
        this.role = value
        // 如果是主播
        const audioStore = useAudioStore()
        const roomStore = useRoomStore()
        if (this.role == 'host') {
          // 如果进房成功
          if (this.joined) {
            const Trtc = window.TRTC
            await client.switchRole(Trtc.TYPE.ROLE_ANCHOR, {
              privateMapKey: audioStore.rtcInfoMin.token
            })
            console.log('TrtcSDK => 设置主播角色成功', value)
          }
        } else if (this.role === 'audience') {
          // 如果进房成功
          if (this.joined) {
            const Trtc = window.TRTC
            await client.switchRole(Trtc.TYPE.ROLE_AUDIENCE, {
              privateMapKey: roomStore.rtcInfo.token
            })
            console.log('TrtcSDK => 设置观众角色成功', value)
          }
        }
      }
    },
    /** 设置前后置摄像头 */
    async switchCamera() {
      const agoraStore = useAgoraStore()
      const i18n = useNuxtApp().$i18n
      showLoadingToast()
      if (agoraStore.videoinputNum >= 2) {
        const facingMode = this.facingMode === 'user' ? 'environment' : 'user'
        await client
          .updateLocalVideo({
            option: {
              useFrontCamera: facingMode == 'user',
              mirror: facingMode === 'user' ? 'both' : false // 前置摄像头镜像，后置摄像头非镜像
            }
          })
          .then(() => {
            showToast(i18n.t('public.Success'))
            this.facingMode = facingMode
            console.log('TrtcSDK => 摄像头朝向', this.facingMode || '无')
          })
          .catch(() => {
            showToast(i18n.t('live.failedSwitch'))
          })
      } else {
        showToast(i18n.t('live.failedSwitch'))
      }
    },
    /**
     * 当远端用户成功发布音视频轨道之后函数
     * TRTC 有主路视频流（主流）和辅路视频流（辅流）streamType
     * 摄像头通过主流发布，屏幕分享通过辅流发布。
     */
    async onRemoteVideoAvailable({ userId, streamType }) {
      console.log(
        'TrtcSDK => 远程用户',
        userId,
        streamType,
        new Date(),
        new Date().getTime()
      )
      const roomStore = useRoomStore()

      // 视频的房间才显示遮罩层
      this.setIsShowMask(true)

      // 主路视频流，一般是推摄像头的那路流
      this.remoteUsers[userId] = {
        elId: 'trtc_user_' + userId,
        uid: userId,
        streamType
      }
      // 视频的房 开始播放视频
      if (
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE ||
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL
      ) {
        // 等待一下取元素显示直播
        await nextTick()
        client.muteRemoteAudio(userId, false) // 调此API播放音频
        // 开始播放视频
        await client
          .startRemoteVideo({
            userId,
            streamType,
            view: this.remoteUsers[userId].elId
          })
          .then(() => {
            console.log('TrtcSDK => 显示回调', new Date(), new Date().getTime())
            this.isRemoteUserPirstFrame = true

            // 监听远程用户
            this.remoteUsersChange(false)

            this.setIsShowMask(false)

            // 发布成功，判断清除发布超时
            roomStore.closeIsTimeout()

            if (roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL) {
              this.isStartBilling()
            }
          })
      }
    },
    /**
     * 当远端用户取消发布音视频轨道
     * TRTC 有主路视频流（主流）和辅路视频流（辅流）streamType
     * 摄像头通过主流发布，屏幕分享通过辅流发布。
     */
    async onRemoteVideoUnavailable({ userId, streamType }) {
      console.log('TrtcSDK => 离开的远程用户', userId, streamType)
      delete this.remoteUsers[userId]

      this.remoteUsersChange(false) // 监听远程用户
      // trtc.stopRemoteVideo({ userId, streamType })
    },
    /**
     * 当远端用户成功发布音频轨道之后函数
     */
    async onRemoteAudioAvailable({ userId }) {
      console.log('TrtcSDK => 远程用户', userId)
      const audioStore = useAudioStore()
      // 主路视频流，一般是推摄像头的那路流
      this.remoteUsers[userId] = {
        elId: '',
        uid: userId,
        streamType: ''
      }
      await nextTick()
      audioStore.isOpenSound && client.muteRemoteAudio(userId, false) // 调此API播放音频

      // 监听远程用户
      this.remoteUsersChange(false)
    },
    /**
     * 当远端用户取消发布音轨道
     */
    async onRemoteAudioUnavailable({ userId }) {
      console.log('TrtcSDK => 离开的远程用户', userId)
      delete this.remoteUsers[userId]

      this.remoteUsersChange(false) // 监听远程用户
      // trtc.stopRemoteVideo({ userId, streamType })
    },
    /**
     * 所有人音量大小事件
     */
    onAudioVolume(event) {
      const audioStore = useAudioStore()
      // 传参设置音量
      audioStore.setVolumeIndicator(event.result)
    },
    /**
     * 视频房使用
     * 管理本地音视频发布与取消发布
     * @param {boolean} isPut true:发布, false: 取消发布
     */
    async manageLocalAllTrack(isPut: boolean) {
      const roomStore = useRoomStore()
      // 不符合条件就return
      if (
        !(
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL ||
          (roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE &&
            roomStore.isHostLive)
        )
      )
        return

      // 发布
      if (isPut) {
        await client.startLocalAudio()
        await client
          .startLocalVideo({
            view: 'trtcLocalVideo',
            option: {
              useFrontCamera: this.facingMode === 'user', // true:在移动端指定使用前置摄像头, false:
              mirror: this.facingMode === 'user' ? 'both' : false, // 前置摄像头镜像，后置摄像头非镜像
              profile: {
                width: 270,
                height: 480,
                frameRate: 15,
                bitrate: 400
              }
            }
          })
          .then(() => {
            console.log('TrtcSDK => 发布成功')
            this.isVideoPublish = true
            this.isStartBilling()
            // 主播关闭蒙版
            if (roomStore.isHostLive) {
              this.setIsShowMask(false)
            }
            // 发布成功，判断清除发布超时
            roomStore.closeIsTimeout()
          })
      } else {
        // 取消发布，取消发布前提是有进入过
        if (this.joined) {
          await client.stopLocalAudio()
          await client.stopLocalVideo()
          this.setIsShowMask(true)
        }
      }
    },
    /**
     * 语音房使用
     * 管理本地上下麦克风
     * @param {boolean} isPut true:上麦, false:下麦
     */
    async manageLocalAudioMicrophone(isPut: boolean) {
      console.log('TrtcSDK => 语音房管理麦克风', isPut)
      if (isPut) {
        await this.setRole('host')
        client.startLocalAudio().catch((err) => {
          if (JSON.stringify(err).indexOf('DEVICE_ERROR') != -1) {
            const agoraStore = useAgoraStore()
            agoraStore.setAuthPopupConfig(true)

            const audioStore = useAudioStore()
            // 麦克风图标显示
            audioStore.setIsOpenMic(false)
          }
        })
      } else {
        client.stopLocalAudio()
        this.setRole('audience')
      }
    },
    /**
     * 语音房使用
     * 开关远程所有音频轨道
     * @param {boolean} isPlay true:播放, false:不播放
     */
    switchAllRemoteAudioTrack(isPlay: boolean) {
      client.muteRemoteAudio('*', !isPlay)
    },
    // room遮罩层设置
    setIsShowMask(show: boolean) {
      const roomStore = useRoomStore()
      if (
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE ||
        roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL
      ) {
        roomStore.setIsShowMask(show)
      }
    },
    /**
     * 监听远程用户
     * @param {boolean} isInit 是否初始化
     */
    remoteUsersChange(init: boolean) {
      const roomStore = useRoomStore()
      roomStore.whetherHostIsLive(init ? [] : Object.keys(this.remoteUsers)) // 监听远程用户
    },
    // 离开
    async exit() {
      const Trtc = window.TRTC
      const roomStore = useRoomStore()
      // 如果以销毁就不再销毁
      if (!this.isDestroyed()) {
        // 注销监听事件
        // 音频房
        if (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE) {
          client.off(
            Trtc.EVENT.REMOTE_AUDIO_AVAILABLE,
            this.onRemoteAudioAvailable
          )
          client.off(
            Trtc.EVENT.REMOTE_AUDIO_UNAVAILABLE,
            this.onRemoteAudioUnavailable
          ) // 取消发布
          // 音量回调事件
          client.off(Trtc.EVENT.AUDIO_VOLUME, this.onAudioVolume)
          // 如需关闭音量回调，传入 interval 值小于等于0即可
          client.enableAudioVolumeEvaluation(-1)
        }
        // 视频房
        if (
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_LIVE ||
          roomStore.roomType === constant.ROOM_TYPE.VIDEO_CALL
        ) {
          client.off(
            Trtc.EVENT.REMOTE_VIDEO_AVAILABLE,
            this.onRemoteVideoAvailable
          )
          client.off(
            Trtc.EVENT.REMOTE_VIDEO_UNAVAILABLE,
            this.onRemoteVideoUnavailable
          )
        }

        // 退出房间和关闭摄像头和麦克风
        await client.exitRoom()
        await client.stopLocalAudio()
        await client.stopLocalVideo()

        this.remoteUsersChange(true) // 初始化

        // 销毁
        client.destroy()
        this.resetData()
        console.log('TrtcSDK => 销毁成功')
      } else {
        console.log('TrtcSDK => 已销毁，不再执行销毁流程')
      }
    },
    // 重置数据
    resetData() {
      this.joined = false
      this.remoteUsers = {}
      this.isVideoPublish = false
      this.isRemoteUserPirstFrame = false
    }
  }
})
